import { render } from "./IndexProgramme.vue?vue&type=template&id=b60d8dbc&scoped=true"
import script from "./IndexProgramme.vue?vue&type=script&lang=js"
export * from "./IndexProgramme.vue?vue&type=script&lang=js"

import "./IndexProgramme.vue?vue&type=style&index=0&id=b60d8dbc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b60d8dbc"]])

export default __exports__